import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChatIcon from "@mui/icons-material/Chat";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ScienceIcon from "@mui/icons-material/Science";
import LogoutIcon from "@mui/icons-material/Logout";
import "./AppLayout.css";

function AppLayout({ children, onLogout, unreadCount }) {
  const location = useLocation();
  const isChat = location.pathname === "/chat";

  return (
    <div className={`app-layout ${isChat ? "chat-mode" : ""}`}>
      <nav className="app-nav">
        <div className="app-nav-brand">
          <span className="brand-text">CF</span>
        </div>
        <div className="app-nav-links">
          <NavLink to="/" end className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} title="Dashboard">
            <span className="nav-icon"><DashboardIcon fontSize="inherit" /></span>
            <span className="nav-label">Dashboard</span>
          </NavLink>
          <NavLink to="/chat" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} title="Chat">
            <span className="nav-icon"><ChatIcon fontSize="inherit" /></span>
            <span className="nav-label">Chat</span>
            {unreadCount > 0 && <span className="nav-badge">{unreadCount}</span>}
          </NavLink>
          <NavLink to="/orders" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} title="Orders">
            <span className="nav-icon"><ShoppingBagIcon fontSize="inherit" /></span>
            <span className="nav-label">Orders</span>
          </NavLink>
          <NavLink to="/message-scripts" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} title="Message Scripts">
            <span className="nav-icon"><ArticleIcon fontSize="inherit" /></span>
            <span className="nav-label">Scripts</span>
          </NavLink>
          <NavLink to="/test" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} title="Test Messages">
            <span className="nav-icon"><ScienceIcon fontSize="inherit" /></span>
            <span className="nav-label">Test</span>
          </NavLink>
        </div>
        <div className="app-nav-bottom">
          <button className="nav-item" onClick={onLogout} title="Sign Out">
            <span className="nav-icon"><LogoutIcon fontSize="inherit" /></span>
            <span className="nav-label">Logout</span>
          </button>
        </div>
      </nav>
      <main className="app-content">
        {children}
      </main>
    </div>
  );
}

export default AppLayout;
